import Queries from 'src/services/graphql/queries/index';
import { TriggerableStatInput } from 'src/services/graphql/Models';
import TriggerableStat from './classes/TriggerableStat';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';
import { processPotentialArray } from 'src/shared/utility';

export class TriggerableStatStore extends DataStoreExtension<TriggerableStatInput, TriggerableStat> {
    listQueries: DocumentNode =  Queries.ListTriggerableStats;
    
    _createQueries = () => authStore.isSuperUser ? Queries.CreateTriggerableStats : undefined;
    _updateQueries = () => authStore.isSuperUser ? Queries.UpdateTriggerableStats : undefined;
    _deleteQueries = () => authStore.isSuperUser ? Queries.DeleteTriggerableStats : undefined;
    
    listVariables: any = () => ({
        input: {
            clientId: authStore.clientId,
            typedId: 'ts'
        }
    })

    constructor() {
        super(false);
    }

    toObject(from: TriggerableStatInput): TriggerableStat {
        return new TriggerableStat(from);
    }

    countError(obj: TriggerableStatInput) {
        let errors = [];
        return errors;
    }

    parseDelete(obj: TriggerableStat) {
        return this.parseClientDelete(obj);
    }

    getChartTriggers(chartId: string) {
        let stats = this.getParsedItems;
        let result: TriggerableStat[] = [];
        processPotentialArray(stats, stat => {
            stat.forEach(o => {
                if (o.associatedChart === chartId ) {
                    result.push(o);
                }
            });
        });
        return result;
    }

}

export default new TriggerableStatStore();


// WEBPACK FOOTER //
// ./src/stores/application/triggerablestat.ts